import React, { useEffect, useState } from "react";

import { useStateValue } from "../../../../State";
import Languages from "../../../../translations";
import Drawer from "@mui/material/Drawer";

import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import ChildProfilePicture from "../../../ChildProfilePicture";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";

import InvoiceDialog from "../../../CareTimeBooking/CareTimeBookingSuccess/CareTimeBookingContent/InvoiceDialog";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";

import { red } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Skeleton from "@mui/material/Skeleton";
import Warning from "@mui/icons-material/Warning";

const CareTimeCalendarSummaryDrawer = (
  { CTBdrawerOpen, CTBhandleDrawerOpen, childList },
  props
) => {
  const { actions, state } = useStateValue();

  const [summaryTableOpen, setSummaryTableOpen] = React.useState(false);

  const [curMonth, setCurMonth] = React.useState(moment());

  const requestedTimespan = {
    Start: curMonth.startOf("month").format("YYYY-MM-DDThh:mm:ss"),
    End: curMonth.endOf("month").format("YYYY-MM-DDThh:mm:ss"),
  };

  const handleMonthChange = (dir) => {
    if (dir === "right") {
      curMonth.add(1, "months");
    } else {
      curMonth.add(-1, "months");
    }
    actions.triggerLoadNursingTimesSummary({
      Start: curMonth.startOf("month").format("YYYY-MM-DD") + "T00:00:00",
      End: curMonth.endOf("month").format("YYYY-MM-DD") + "T23:59:59",
    });
  };
  const [selectedChildId, setSelectedChildId] = React.useState("");
  useEffect(() => {
    if (CTBdrawerOpen) {
      actions.triggerLoadNursingTimesSummary({
        Start: curMonth.startOf("month").format("YYYY-MM-DD") + "T00:00:00",
        End: curMonth.endOf("month").format("YYYY-MM-DD") + "T23:59:59",
      });
    }
  }, [CTBdrawerOpen]);
  //console.log(props.childList);
  const CTBSummary = state.nursingTimesSummary.NT;

  const openSummaryTable = (Id) => {
    setSelectedChildId(Id);
    setSummaryTableOpen(true);
  };

  const closeSummaryTable = () => {
    setSummaryTableOpen(false);
  };

  return (
    <Drawer
      anchor={"bottom"}
      open={CTBdrawerOpen}
      onClose={CTBhandleDrawerOpen}
      PaperProps={{
        sx: {
          margin: "auto",
          maxWidth: 800,
          width: "100%",
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          mb: "40px",
          color: "white",
          backgroundColor: "white",
        },
      }}
      sx={{ zIndex: 0 }}
      transitionDuration={{ enter: 600, exit: 400 }}
    >
      {(state.nursingTimesSummary.NT.status === "LOADING_NT_SUMMARY" ||
        state.nursingTimesSummary.NT.status === "NEVER_LOADED") && (
        <>
          <Box
            sx={{
              width: "auto",
              height: "auto",
              "&::-webkit-scrollbar": { display: "none" },
              msOverflowStyle: "none",
              scrollbarWidth: "none",
              backgroundColor: "white",
              borderTopLeftRadius: "inherit",
              borderTopRightRadius: "inherit",
            }}
            role="presentation"
          >
            <Puller />
            <>
              <Box sx={{ mt: 3, ml: "30%" }}>
                <Skeleton sx={{ bgcolor: "lightgrey" }}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <IconButton onClick={() => handleMonthChange("left")}>
                      <ChevronLeftIcon />
                    </IconButton>
                    <Stack>
                      <Typography
                        color="textSecondary"
                        fontSize="medium"
                        align="center"
                      >
                        {moment(requestedTimespan.Start).format("MMMM")}
                      </Typography>
                      <Typography
                        color="textSecondary"
                        fontSize="medium"
                        align="center"
                      >
                        {moment(requestedTimespan.Start).format("YYYY")}
                      </Typography>
                    </Stack>

                    <IconButton onClick={() => handleMonthChange("right")}>
                      <ChevronRightIcon />
                    </IconButton>
                  </Stack>
                </Skeleton>
              </Box>
              <Divider />
            </>
            <Box
              sx={{
                maxHeight: "500px",
                overflow: "auto",
                "&::-webkit-scrollbar": { display: "none" },
                msOverflowStyle: "none",
                scrollbarWidth: "none",
              }}
            >
              <List sx={{ ml: "2.5%", mt: 1 }}>
                {childList.map((child) => (
                  <Card
                    key={child.id}
                    variant="outlined"
                    sx={{
                      bgcolor: "white",
                      width: "95%",
                      mb: 1,
                    }}
                  >
                    <CardHeader
                      sx={{ pb: 0 }}
                      avatar={
                        <Skeleton
                          variant="circular"
                          sx={{ bgcolor: "lightgrey" }}
                        >
                          <Avatar />
                        </Skeleton>
                      }
                      title={
                        <Typography color="textSecondary">
                          {
                            <Skeleton
                              width="30%"
                              sx={{ bgcolor: "lightgrey" }}
                            />
                          }
                        </Typography>
                      }
                      action={
                        <Skeleton sx={{ bgcolor: "lightgrey", mt: 1 }}>
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ backgroundColor: "#00B3DF" }}
                          >
                            {Languages.uctInvoiceBasis}
                          </Button>
                        </Skeleton>
                      }
                    />

                    <CardContent
                      sx={{ pb: 0, pt: 0, "&:last-child": { pb: 0 }, ml: 1 }}
                    >
                      <List sx={{ pd: 0, ml: 1 }}>
                        <ListItemText>
                          <Typography color="textSecondary">
                            {<Skeleton sx={{ bgcolor: "lightgrey" }} />}
                          </Typography>
                        </ListItemText>
                        <ListItemText>
                          <Typography color="textSecondary">
                            {<Skeleton sx={{ bgcolor: "lightgrey" }} />}
                          </Typography>
                        </ListItemText>
                        <ListItemText>
                          <Typography color="textSecondary">
                            {<Skeleton sx={{ bgcolor: "lightgrey" }} />}
                          </Typography>
                        </ListItemText>
                        <ListItemText>
                          <Typography color="textSecondary">
                            {<Skeleton sx={{ bgcolor: "lightgrey" }} />}
                          </Typography>
                        </ListItemText>
                      </List>
                    </CardContent>
                  </Card>
                ))}
              </List>
            </Box>
          </Box>
        </>
      )}

      {state.nursingTimesSummary.NT.status === "NT_SUMMARY_LOAD_SUCCESS" && (
        <Box
          sx={{
            width: "auto",
            height: "auto",

            backgroundColor: "white",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit",
          }}
          role="presentation"
        >
          <Puller />
          <>
            <Box sx={{ mt: 3, ml: "30%" }}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <IconButton onClick={() => handleMonthChange("left")}>
                  <ChevronLeftIcon />
                </IconButton>
                <Stack>
                  <Typography
                    color="textSecondary"
                    fontSize="medium"
                    align="center"
                  >
                    {moment(requestedTimespan.Start).format("MMMM")}
                  </Typography>
                  <Typography
                    color="textSecondary"
                    fontSize="medium"
                    align="center"
                  >
                    {moment(requestedTimespan.Start).format("YYYY")}
                  </Typography>
                </Stack>

                <IconButton onClick={() => handleMonthChange("right")}>
                  <ChevronRightIcon />
                </IconButton>
              </Stack>
            </Box>
            <Divider />
          </>
          <Box sx={{ maxHeight: "500px", overflow: "auto" }}>
            <List sx={{ ml: "2.5%", mt: 1 }}>
              {CTBSummary.ListChildStats.map((stat) => (
                <Card
                  key={stat.childPersonId}
                  variant="outlined"
                  sx={{
                    bgcolor: "white",
                    width: "95%",
                    mb: 1,
                  }}
                >
                  <CardHeader
                    sx={{ pb: 0 }}
                    avatar={
                      <Avatar>
                        <ChildProfilePicture childId={stat.childPersonId} />
                      </Avatar>
                    }
                    title={
                      <Typography color="textSecondary">
                        {stat.childName.split(", ")[1].charAt(0).toUpperCase() +
                          stat.childName.split(", ")[1].slice(1).toLowerCase() +
                          " " +
                          stat.childName
                            .split(", ")[0]
                            .charAt(0)
                            .toUpperCase() +
                          stat.childName.split(", ")[0].slice(1).toLowerCase()}
                      </Typography>
                    }
                    action={
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => openSummaryTable(stat.childPersonId)}
                        sx={{ backgroundColor: "#00B3DF", mt: 1 }}
                      >
                        {Languages.uctInvoiceBasis}
                      </Button>
                    }
                  />

                  <CardContent
                    sx={{ pb: 0, pt: 0, "&:last-child": { pb: 0 }, ml: 1 }}
                  >
                    <List sx={{ pd: 0, ml: 1 }}>
                      <ListItemText>
                        <Typography color="textSecondary">
                          {Languages.newCalendarServiceNeed +
                            ": " +
                            stat.serviceneedType}
                        </Typography>
                      </ListItemText>
                      <ListItemText>
                        <Typography color="textSecondary">
                          {Languages.newCalendarPaymentCategory +
                            ": " +
                            stat.paymentcategory}
                        </Typography>
                      </ListItemText>
                      <ListItemText>
                        <Typography color="textSecondary">
                          {Languages.newCalendarFreeTime +
                            ": " +
                            stat.freeHours}
                        </Typography>
                      </ListItemText>
                      <ListItemText>
                        <Typography color="textSecondary">
                          {Languages.newCalendarUsedTime +
                            ": " +
                            stat.spentHoursOrDays +
                            " / " +
                            stat.maxSpendAvailable}
                        </Typography>
                      </ListItemText>
                      {stat.specificChildOverBookingWarning && (
                        <ListItemText>
                          <Box display="flex">
                            <Warning color="error" sx={{ mr: 1 }} />
                            <Typography color="error">
                              {Languages.newCalendarExceedWarning}
                            </Typography>
                          </Box>
                        </ListItemText>
                      )}
                    </List>
                  </CardContent>
                </Card>
              ))}
            </List>
          </Box>
        </Box>
      )}
      {summaryTableOpen && (
        <InvoiceDialog
          timespan={{
            start: moment(requestedTimespan.Start).format("YYYY-MM-DD"),
            end: moment(requestedTimespan.End).format("YYYY-MM-DD"),
          }}
          childId={selectedChildId}
          close={closeSummaryTable}
        ></InvoiceDialog>
      )}
    </Drawer>
  );
};

export default CareTimeCalendarSummaryDrawer;

const Puller = styled(Box)(() => ({
  width: 30,
  height: 6,
  backgroundColor: "#cccccc",
  borderRadius: 3,
  position: "absolute",
  top: 8,
  left: "calc(50% - 15px)",
}));
